import { Text } from '@uhg-abyss/web/ui/Text';
import { Box } from '@uhg-abyss/web/ui/Box';

export const Logout = () => {
  return (
    <Box
      css={{
        'abyss-box-root': {
          padding: '16px',
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        },
      }}
    >
      <Box
        css={{
          'abyss-box-root': {
            backgroundColor: '$web.semantic.color.surface.container.secondary',
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            borderRadius: '8px',
            boxShadow: '0px 10px 40px rgba(0, 0, 0, 0.1)',
            maxWidth: '500px',
            textAlign: 'center',
          },
        }}
      >
        <Box
          css={{
            'abyss-box-root': {
              width: '80px',
              height: '80px',
              borderRadius: '50%',
              backgroundColor: '#007000',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: '8px',
            },
          }}
        >
          <Text
            css={{
              fontSize: '48px',
              color: '$web.semantic.color.text.content.primary-alt',
            }}
          >
            ✓
          </Text>
        </Box>

        <Text
          css={{
            fontSize: '16px',
            fontWeight: '700',
            color: '$web.semantic.color.text.content.primary',
            marginBottom: '0px',
          }}
        >
          Successfully Logged Out
        </Text>

        <Text
          css={{
            fontSize: '18px',
            color: '$web.semantic.color.text.content.secondary',
            lineHeight: '1.6',
            marginBottom: '2px',
          }}
        >
          You have been safely logged out of the EEMS Online application.
        </Text>

        <Text
          css={{
            fontSize: '16px',
            color: '$web.semantic.color.text.content.tertiary',
          }}
        >
          To access the application again, please{' '}
          <a
            href="/login"
            style={{
              color: '#0066cc',
              textDecoration: 'none',
              fontWeight: 'bold',
            }}
          >
            log back in
          </a>
          .
        </Text>
      </Box>
    </Box>
  );
};
